import { B2C_ONBOARDING_PAGES, TRACK_EVENTS } from "core/consts";
import Tile, { TILETYPE } from "ds_legacy/components/TileButton";
import { UserIcon, UsersIcon } from "lucide-react";
import { useTracking } from "react-tracking";
import OnboardingCard, { PageProps, StyledCaption, testIds } from "../common";

const FOR_MYSELF = "for myself";
const FOR_SOMEONE = "for someone";

export default function Target({ navigateToPage, translations }: PageProps) {
  const { trackEvent } = useTracking();

  const gotoNext = (target: string) => {
    navigateToPage(B2C_ONBOARDING_PAGES.START_DATE);
    trackEvent({
      name: TRACK_EVENTS.DASHBOARD_FILTERS,
      search_target: target,
    });
  };
  return (
    <OnboardingCard
      data-testid={testIds.target}
      navigateToPage={navigateToPage}
      title={translations.bToC.onboardingScreens.titleForWhom}
    >
      <StyledCaption>
        {translations.bToC.onboardingScreens.yourChoice}:
      </StyledCaption>
      <Tile
        Icon={UserIcon}
        label={translations.bToC.onboardingScreens.buttonForMyself}
        tileType={TILETYPE.B2C}
        onClick={() => gotoNext(FOR_MYSELF)}
      />
      <Tile
        Icon={UsersIcon}
        label={translations.bToC.onboardingScreens.buttonForSomeoneElse}
        tileType={TILETYPE.B2C}
        onClick={() => gotoNext(FOR_SOMEONE)}
      />
    </OnboardingCard>
  );
}
